import { render, staticRenderFns } from "./RetencionesPercepciones.vue?vue&type=template&id=664fb068"
import script from "./RetencionesPercepciones.vue?vue&type=script&lang=js"
export * from "./RetencionesPercepciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports